import axios from "axios";
import { useState, useRef, useEffect } from "react";

import Input from '@/components/Input';
import Switch from '@/components/Switch';

import Button from '@/components/Button';

import { getErrorMessage, checkInputErrors } from '@/utils/Errors';

export default function CopyTables({t,language,user,apiUrl,token,sendMessage,setRootAnswer,handleLogin}){

    const [ data, setData ] = useState({
        sourceDB: 'app_gestion',
        targetDBlist: '',
        targetDBprefix: 'app_emp_',
        tablesList: '',
        tablesPrefix: '',
        overwriteExisting: false,
        copyData: false
    });

    const [ errors, setErrors ] = useState(null);

    const divRef = useRef(null); 

    useEffect(() => {
        // scroll to div
        if(divRef.current) {
            divRef.current.scrollIntoView({ 
                behavior: 'smooth',
                block: 'start'
            });
        }
        
    }, []);

    // to loop with text fields
    const textFields = ['sourceDB','targetDBlist','targetDBprefix','tablesList','tablesPrefix'];

    const handleInput = (e) => {
        
        var name = e.target.name;
        var value = e.target.value;

        var newData = {...data};
        newData[name] = value;
        setData(newData);
    };

    const handleInputSwitch = (e) => {
        
        const name = e.target.name;
        var value = e.target.checked;
        
        var newData = {...data};
        newData[name] = value;
        setData(newData);
    }

    const handleSubmit = () => {

        const fieldsNotEmpty = ['sourceDB'];

        const fieldsOneMustBeNotEmpty = [
            ['targetDBlist','targetDBprefix'],
            ['tablesList','tablesPrefix']
        ];

        const errorsCheck = checkInputErrors(data,fieldsNotEmpty,fieldsOneMustBeNotEmpty);

        if(Object.keys(errorsCheck).length === 0){
            
            const apiPath = '/database/copyTables';

            const config = {
                headers: { Authorization: `Bearer ${token}` } 
            };

            const send = {...data};

            send.language = language;
            send.companyuser = user?.company;

            var errorMessage = t('root.copy_tables.errors.copy');
            
            const url = apiUrl+apiPath;
            
            axios.post(url,send,config)
            .then(function (response) {

                if(response?.data){
              
                    const responseData = response.data;                

                    // if result is ok (1)
                    if(responseData?.result){
                        
                        sendMessage(t('root.copy_tables.copied'));

                        const responseTables = responseData?.data;

                        const render = 
                            <div className='mt-4'>                                       
                                <div className="text-center">
                                    {
                                        responseTables && Object?.keys(responseTables)?.length > 0 &&
                                        Object?.keys(responseTables)?.map((database) => (
                                            <>
                                            <div className='font-bold border-b border-t mb-2'>
                                                {database}
                                            </div>
                                            <div className='border border-b rounded p-1'>
                                                {
                                                    responseTables[database] && Object?.keys(responseTables[database])?.length > 0 &&
                                                    Object?.keys(responseTables[database])?.map((table) => (
                                                        <>
                                                        <div>
                                                            {table}
                                                        </div>
                                                        <div>
                                                            {responseTables[database][table]?.status}
                                                        </div>
                                                        <div>
                                                            {responseTables[database][table]?.message}
                                                        </div>
                                                        </>
                                                    ))
                                                }
                                            </div>
                                            </>
                                        ))
                                    }
                                </div>
                            </div>
                        ;
                        
                        setRootAnswer(render);
                    } 
                    else{
                        if(responseData?.status && responseData.status === 401){
                            handleLogin();                        
                        }
                        else{
                            // check error message
                            if(responseData?.data?.reasons){
                                errorMessage = getErrorMessage(t,'root.copy_tables',responseData?.data?.reasons);                                
                            }
                            
                            sendMessage(errorMessage,'error');
                        }                        
                    }
                }
                else{                
                    sendMessage(errorMessage,'error');                    
                }
            })
            .catch(function (error){
                
                if(error?.status && error.status === 401){
                    handleLogin();                        
                }
                else{                        
                    sendMessage(errorMessage,'error');
                }
            });
        }
        else{            
            const errorMessage = getErrorMessage(t,'root.copy_tables',errorsCheck);
            setErrors(errorsCheck);
            sendMessage(errorMessage,'error');
        }
    }

	return (
        <div className='mt-4' ref={divRef}>
            <div className='mb-4'>
                {t('root.copy_tables.description')}
            </div>
            {
                textFields && textFields?.length > 0 &&
                textFields?.map((textField) => (
                    <div className='mb-4' key={'root.copy_tables.field.'+textField}>
                        <Input                      
                            name={textField}
                            type="text"
                            value={Object.hasOwn(data,textField) && data[textField]}                      
                            placeholder={t('root.copy_tables.fields.'+textField)}                    
                            onChange={handleInput}
                            error={errors && Object.hasOwn(errors,textField) && errors[textField] ? t('root.copy_tables.errors.'+errors[textField]) : ''}                    
                        />
                    </div>
                ))
            }
            <div className='mb-4'>
                <Switch                                                                    
                    name='overwriteExisting'
                    checked={data.overwriteExisting}
                    label={t('root.copy_tables.fields.overwriteExisting')}
                    onChange={handleInputSwitch}                              
                />
            </div>
            <div className='mb-4'>
                <Switch                                                                    
                    name='copyData'
                    checked={data.copyData}
                    label={t('root.copy_tables.fields.copyData')}
                    onChange={handleInputSwitch}                              
                />
            </div>
            <div className='mb-4 flex justify-center'>
                <div className='me-1'>
                    <Button                     
                        onClick={handleSubmit}
                        text={t('root.copy_tables.button')}
                        type='accept'
                    />
                </div>
            </div>
        </div>
    );
}